import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { actions } from 'store/newDocumentStore';
import DocumentLoader from 'routes/Documents/containers/DocumentLoaderContainer';
import DocumentProvider from 'routes/Documents/containers/DocumentProvider';

import Comorbidity from '../components/Comorbidity';

const ComorbidityContainer = ({ edit, create }) => (
  <DocumentLoader names={['comorbidity']}>
    <DocumentProvider>
      <Comorbidity onStartEdit={edit} onCreate={create} />
    </DocumentProvider>
  </DocumentLoader>
);

ComorbidityContainer.propTypes = {
  edit: PropTypes.func,
  create: PropTypes.func,
};

export default connect(null, { edit: actions.createCommit, create: actions.createDocumentAndCommit })(
  ComorbidityContainer,
);
